/**
 * Created by Languagenut on 19/06/2019.
 */

import React  from 'react';
import {Col , Row , Modal , Button} from 'react-bootstrap'
import Select from  'react-select';
import Translation from  '../../store/internationalization-store.js';

export default class TextPopup extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        console.log(this.props);

        this.state = {
            multiSelect:this.props.data || [],
            value:this.props.value || []
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.state = {
            multiSelect:this.props.data || [],
            value:this.props.value || []
        };
    }


    onChange(params) {

        this.setState({
            value:params
        })
    }

    onSave(){
        if(this.props.onSave) this.props.onSave(this.state.value);
        this.props.onHide();
    }

    optionClicked(optionsList) {
        this.setState({ multiSelect: optionsList });
    }
    selectedBadgeClicked(optionsList) {
        this.setState({ multiSelect: optionsList });
    }

    render() {

        const {selected} = this.state;
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {this.props.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="strong">
                        <Col md={12}>
                            <div >
                                <Select placeholder={Translation.get(892, "Select")} isMulti={false} onChange={this.onChange.bind(this)} name="form-field-name" value={this.state.value} 
                                    options={this.props.data} className={this.props.className}/>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
            <Button onClick={this.onSave.bind(this)}>{Translation.get(657, "Save")}</Button> <Button onClick={this.props.onHide}>{Translation.get(629, "Close")}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}